// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import axios from 'axios'
import '@/globals'
import '@/plugins/vuetify'
import appData from '@/helpers/app-data'
import App from '@/App.vue'
import GeoShow from '@/pages/Geo/Show'
import VueRouter from 'vue-router'
import Meta from 'vue-meta'
import store from '@/store'
import registerAirbrake from '@/plugins/airbrake'

if (!appData.get('geo')) {
  throw "Could not find global initialization object 'geo'. In production mode the server side needs to insert the initialization code in a script tag prior to executing the vue bundle."
}

/**
 * Some functions may be disabled while remote calls are being made. This function helps achieve that.
 */
(function watchXhrs () {
  axios.interceptors.request.use(function (config) {
    store.dispatch('geo/increaseXhrCount')
    return config
  }, function (error) { return Promise.reject(error) })

  axios.interceptors.response.use(function (response) {
    store.dispatch('geo/decreaseXhrCount')
    return response
  }, function (error) {
    store.dispatch('geo/decreaseXhrCount')
    return Promise.reject(error)
  })
})()

Vue.use(VueRouter)
Vue.use(Meta)

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      name: 'geo-show',
      path: '/g/:geoId/:stg?/:st?', // e.g. '/g/california/utilities/gas'
      component: GeoShow
    }
  ]
})

/* eslint-disable no-new */
new Vue({
  router,
  el: '#app',
  render: h => h(App),
  store
})

registerAirbrake()



// WEBPACK FOOTER //
// ./frontend/src/packs/geo.js